import { HashtagInfo } from 'shared/models';
import { ITopicUnavailableDetail } from 'shared/models';

export const TopicUtil = {
  isTopicAvailable: (topic: HashtagInfo | ITopicUnavailableDetail): topic is HashtagInfo => {
    return !('unavailableReason' in topic);
  },
};
